(function () {
  'use strict';

  var modal = document.querySelector('[data-woodarq-search-modal]');
  if (!modal) return;

  var input = modal.querySelector('[data-woodarq-search-input]');
  var form = modal.querySelector('[data-woodarq-search-form]');
  var results = modal.querySelector('[data-woodarq-search-results]');
  var closeButtons = modal.querySelectorAll('[data-woodarq-search-close]');
  var lastFocusedElement = null;
  var debounceTimer = null;
  var abortController = null;
  var resultCache = Object.create(null);
  var latestQuery = '';
  var isOpen = false;

  if (!input || !form || !results) return;

  modal.classList.add('is-ready');

  function getTriggers() {
    return document.querySelectorAll('[data-woodarq-search-trigger]');
  }

  function setTriggerExpanded(expanded) {
    getTriggers().forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function focusSearchInput() {
    window.setTimeout(function () {
      try {
        input.focus({ preventScroll: true });
      } catch (error) {
        input.focus();
      }
    }, 80);
  }

  function closeMiniCartIfOpen() {
    var miniCart = document.querySelector('.mini-cart.mini-cart_active');
    if (!miniCart) return;

    var miniCartClose = miniCart.querySelector('.close');
    if (miniCartClose) {
      miniCartClose.click();
      return;
    }

    miniCart.classList.remove('mini-cart_active');
    var activeContent = miniCart.querySelector('.mini-cart-content_active');
    if (activeContent) activeContent.classList.remove('mini-cart-content_active');

    var activeBackdrop = document.querySelector('.mini-cart-global-backdrop_active');
    if (activeBackdrop) activeBackdrop.classList.remove('mini-cart-global-backdrop_active');
  }

  function closePdpMegaMenuIfOpen() {
    document.querySelectorAll('[data-pdp-v2-mega-trigger][aria-expanded="true"]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.classList.remove('is-active');
      trigger.classList.remove('is-mega-active');
    });

    document.querySelectorAll('[data-pdp-v2-mega]').forEach(function (mega) {
      mega.hidden = true;
      mega.classList.remove('is-active');
    });

    if (document.body) document.body.classList.remove('pdp-v2-header-mega-open');
  }

  function openSearch() {
    if (isOpen) {
      focusSearchInput();
      return;
    }

    lastFocusedElement = document.activeElement;
    closeMiniCartIfOpen();
    closePdpMegaMenuIfOpen();
    isOpen = true;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('woodarq-search-open');
    document.documentElement.classList.add('woodarq-search-is-open');
    setTriggerExpanded(true);
    focusSearchInput();
  }

  function closeResults() {
    modal.classList.remove('has-results', 'is-loading');
    latestQuery = '';
    if (abortController) {
      abortController.abort();
      abortController = null;
    }
  }

  function closeSearch() {
    if (!isOpen) return;

    isOpen = false;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('woodarq-search-open');
    document.documentElement.classList.remove('woodarq-search-is-open');
    setTriggerExpanded(false);
    closeResults();
    input.blur();

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      window.setTimeout(function () {
        try {
          lastFocusedElement.focus({ preventScroll: true });
        } catch (error) {
          lastFocusedElement.focus();
        }
      }, 120);
    }
  }

  function buildSuggestUrl(query) {
    var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    var params = new URLSearchParams();
    params.set('q', query);
    params.set('resources[type]', 'product');
    params.set('resources[limit]', '8');
    params.set('section_id', 'predictive-search');
    return base + '?' + params.toString();
  }

  function extractSectionHtml(markup) {
    var doc = new DOMParser().parseFromString(markup, 'text/html');
    var section = doc.querySelector('#shopify-section-predictive-search');
    return section ? section.innerHTML : '';
  }

  function renderResults(html) {
    results.innerHTML = html;
    modal.classList.remove('is-loading');
    modal.classList.toggle('has-results', html.trim().length > 0);
  }

  function showLoading() {
    results.innerHTML = '<p class="woodarq-search-loading">Searching...</p>';
    modal.classList.add('is-loading');
    modal.classList.remove('has-results');
  }

  function fetchResults(query) {
    var normalizedQuery = query.trim();
    if (normalizedQuery.length < 2) {
      results.innerHTML = '';
      closeResults();
      return;
    }

    latestQuery = normalizedQuery;

    if (resultCache[normalizedQuery]) {
      renderResults(resultCache[normalizedQuery]);
      return;
    }

    if (abortController) abortController.abort();
    abortController = new AbortController();
    showLoading();

    fetch(buildSuggestUrl(normalizedQuery), {
      signal: abortController.signal,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Search request failed: ' + response.status);
        return response.text();
      })
      .then(function (markup) {
        if (!isOpen || latestQuery !== normalizedQuery) return;
        var html = extractSectionHtml(markup);
        resultCache[normalizedQuery] = html;
        renderResults(html);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (!isOpen || latestQuery !== normalizedQuery) return;
        results.innerHTML = '<p class="woodarq-search-no-results">No results matched your search.</p>';
        modal.classList.remove('is-loading');
        modal.classList.add('has-results');
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-woodarq-search-trigger]');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();
    openSearch();
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      closeSearch();
    });
  });

  input.addEventListener('input', function () {
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(function () {
      fetchResults(input.value);
    }, 220);
  });

  form.addEventListener('submit', function (event) {
    var query = input.value.trim();
    if (!query) {
      event.preventDefault();
      closeResults();
      return;
    }

    input.blur();
  });

  results.addEventListener('click', function (event) {
    var link = event.target.closest('a');
    if (!link) return;
    input.blur();
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('woodarq-search-open');
    document.documentElement.classList.remove('woodarq-search-is-open');
    setTriggerExpanded(false);
  });

  document.addEventListener('keydown', function (event) {
    if (!isOpen) return;

    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      closeSearch();
      return;
    }

    if (event.key !== 'Tab') return;

    var focusable = modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.addEventListener('pageshow', function () {
    if (!isOpen) return;
    focusSearchInput();
  });
})();
